<template>
  <div>
    <div
      class="breadcrumb-area pos-relative w-100"
      v-if="dataPermission.includes('CNPS_DEVICE_ORDER_WARRANTY_VIEW')"
    >
      <h1>Chi tiết phiếu chuyển mục đích sử dụng</h1>
      <div class="btn-group float-right">
        <button class="f12 font-medium btn btn-outline-secondary" @click="approveItem(detail)">
          Duyệt
        </button>
        <button class="f12 font-medium btn btn-outline-secondary" @click="rejectItem(detail)">
          Từ chối
        </button>
        <button class="f12 font-medium btn btn-outline-secondary" @click="edit(detail.id)">
          Sửa
        </button>
        <button class="f12 font-medium btn btn-outline-secondary" @click="cancelItem(detail)">
          Hủy
        </button>
        <button class="f12 font-medium btn btn-outline-secondary" @click="backToList()">
          <i class="bx bx-arrow-back"></i> Quay lại
        </button>
      </div>
    </div>
    <div class="card p-10 pt-15 b-t-1-869fb229">
      <div class="card-body px-20 form-row">
        <div class="col-12">
          <div class="tab-content" id="myTabContent">
            <div class="tab-pane fade show active" id="ttc">
              <div class="form-row">
                <div class="form-detail">
                  <div class="form-group form-row">
                    <label for="" class="col-sm-2 col-form-label"
                      >Vùng<span class="float-right">:</span></label
                    >
                    <div class="col-sm-10">
                      <p class="form-control-plaintext f12">{{ detail.regionName }}</p>
                    </div>
                  </div>

                  <div class="form-group form-row">
                    <label for="" class="col-sm-2 col-form-label"
                      >Người tạo<span class="float-right">:</span></label
                    >
                    <div class="col-sm-10">
                      <p class="form-control-plaintext f12">
                        {{ detail.userCreator ? detail.userCreator.name : '' }}
                      </p>
                    </div>
                  </div>

                  <div class="form-group form-row">
                    <label for="" class="col-sm-2 col-form-label"
                      >Trạng thái<span class="float-right">:</span></label
                    >
                    <div class="col-sm-10">
                      <p class="form-control-plaintext f12">
                        <span class="badge" :class="[detail.status ? detail.status : '']">
                          {{ detail.status | transformData(Config.statusWarranty) }}
                        </span>
                      </p>
                    </div>
                  </div>

                  <div class="form-group form-row">
                    <label for="" class="col-sm-2 col-form-label"
                      >Ghi chú<span class="float-right">:</span></label
                    >
                    <div class="col-sm-10">
                      <p class="form-control-plaintext f12">{{ detail.description }}</p>
                    </div>
                  </div>

                  <div class="form-group form-row">
                    <label for="" class="col-sm-2 col-form-label"
                      >Lý do<span class="float-right">:</span></label
                    >
                    <div class="col-sm-10">
                      <p class="form-control-plaintext f12">
                        {{ detail.reasonUsageChange | transformData(Config.reasonUsageChange) }}
                      </p>
                    </div>
                  </div>

                  <div class="form-group form-row">
                    <label for="" class="col-sm-2 col-form-label"
                      >Ngày tạo<span class="float-right">:</span></label
                    >
                    <div class="col-sm-10">
                      <p class="form-control-plaintext f12">
                        {{ detail.dateCreate | formatDate('HH:mm, DD/MM/YYYY') }}
                      </p>
                    </div>
                  </div>

                  <div class="form-group form-row" v-if="detail.status === 'APPROVED'">
                    <label for="" class="col-sm-2 col-form-label"
                      >Người duyệt<span class="float-right">:</span></label
                    >
                    <div class="col-sm-10">
                      <p class="form-control-plaintext f12">
                        {{ detail.personApprove ? detail.personApprove.name : '' }}
                      </p>
                    </div>
                  </div>
                  <div class="form-group form-row" v-if="detail.status === 'APPROVED'">
                    <label for="" class="col-sm-2 col-form-label"
                      >Ngày duyệt<span class="float-right">:</span></label
                    >
                    <div class="col-sm-10">
                      <p class="form-control-plaintext f12">
                        {{ detail.timeApprove | formatDate('HH:mm, DD/MM/YYYY') }}
                      </p>
                    </div>
                  </div>
                  <div
                    class="form-group form-row"
                    v-if="detail.status === 'REJECTED' || detail.status === 'REJECT_IMPORT'"
                  >
                    <label for="" class="col-sm-2 col-form-label"
                      >Người từ chối<span class="float-right">:</span></label
                    >
                    <div class="col-sm-10">
                      <p class="form-control-plaintext f12">
                        {{ detail.personReject ? detail.personReject.name : '' }}
                      </p>
                    </div>
                  </div>
                  <div
                    class="form-group form-row"
                    v-if="detail.status === 'REJECTED' || detail.status === 'REJECT_IMPORT'"
                  >
                    <label for="" class="col-sm-2 col-form-label"
                      >Ngày từ chối<span class="float-right">:</span></label
                    >
                    <div class="col-sm-10">
                      <p class="form-control-plaintext f12">
                        {{ detail.timeReject | formatDate('HH:mm, DD/MM/YYYY') }}
                      </p>
                    </div>
                  </div>
                  <div
                    class="form-group form-row"
                    v-if="detail.status === 'REJECTED' || detail.status === 'REJECT_IMPORT'"
                  >
                    <label for="" class="col-sm-2 col-form-label"
                      >Lý do từ chối<span class="float-right">:</span></label
                    >
                    <div class="col-sm-10">
                      <p class="form-control-plaintext f12">{{ detail.reasonRejectImport }}</p>
                    </div>
                  </div>
                </div>
              </div>
              <div class="form-row">
                <div class="form-detail">
                  <div class="d-flex justify-content-between">
                    <h1>Danh sách cần chuyển test</h1>
                  </div>
                  <div class="table-responsive">
                    <table
                      class="table table-hover table-bordered"
                      style="max-height: 400px; overflow-y: auto"
                    >
                      <thead class="thead-light">
                        <tr>
                          <th scope="col" class="text-center">Mã thiết bị</th>
                          <th scope="col" class="text-center">Loại TB</th>
                          <th scope="col" class="text-center">Số lượng</th>
                          <th scope="col" class="text-center">Đơn vị</th>
                          <th scope="col" class="text-center">Tình trạng</th>
                          <th scope="col" class="text-center">Ghi chú</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr class="table-row" v-for="(item, index) in devices" :key="index">
                          <td class="text-center">
                            {{ item.serial }}
                          </td>
                          <td class="text-center">
                            {{ item.categoryName }}
                          </td>
                          <td class="text-center">
                            {{ item.quantity }}
                          </td>
                          <td class="text-center">
                            {{ item.unit | transformData(Config.unitDevice) }}
                          </td>
                          <td class="text-center">
                            <span class="badge" :class="[item.type || '']">
                              {{ item.type | transformData(Config.stateDevices) }}
                            </span>
                          </td>
                          <td class="text-center">
                            {{ item.noteExport }}
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <VueLoadingOverlay :active.sync="showLoading" :is-full-page="true"> </VueLoadingOverlay>
  </div>
</template>
<script>
  import { DeviceService } from '@/services/device.service'
  import { mapGetters } from 'vuex'
  import Config from '@/thirdParty/config'

  export default {
    name: 'usage-change-detail',
    data() {
      return {
        Config,
        showLoading: false,
        dataUser: JSON.parse(localStorage.getItem('userData')) ?? {},
        id: this.$route.params.id,
        detail: {},
        devices: [],
      }
    },
    computed: {
      ...mapGetters({
        dataPermission: 'role/dataPermission',
      }),
    },

    created() {
      this.fetchData()
    },

    methods: {
      backToList() {
        this.$router.push('/usage-change')
      },
      async fetchData() {
        try {
          this.showLoading = true
          const data = await DeviceService.getDetailUsageChange({ id: this.id })
          if (data.success || data.code === 1000) {
            this.detail = data.data
            this.devices = data.data.devices
          }
        } catch (error) {
          console.log(error)
        } finally {
          this.showLoading = false
        }
      },
      edit(id) {
        this.$router.push(`/usage-change/edit/${id}`)
      },
      rejectItem(item) {
        const h = this.$createElement
        const messageVNode = h('div', { class: 'form-group pos-relative' }, [
          h('textarea', { ref: 'rejectValue', class: 'form-control f12' }),
        ])
        this.$bvModal
          .msgBoxConfirm([messageVNode], {
            title: 'Lý do từ chối',
            okTitle: 'Xác nhận',
            cancelTitle: 'Huỷ',
            centered: true,
            okDisabled: false,
          })
          .then(async value => {
            if (value) {
              this.showLoading = true
              const res = await DeviceService.rejectUsageChange({
                id: item.id,
                reasonReject: this.$refs.rejectValue.value,
              })
              if (res.code === 1000) {
                this.fetchData()
                this.showSuccessMx(`Từ chối phiếu chuyển mục đích thành công`)
              } else {
                this.showFailMx(`Từ chối phiếu chuyển mục đích thất bại`)
              }
              this.showLoading = false
            }
          })
          .catch(() => {
            this.showLoading = false
          })
      },
      approveItem(item) {
        const h = this.$createElement
        const messageVNode = h(
          'p',
          { class: 'f14' },
          `Bạn có chắc chắn duyệt phiếu chuyển mục đích không?`
        )
        this.$bvModal
          .msgBoxConfirm([messageVNode], {
            title: 'Lưu ý',
            okTitle: 'Xác nhận',
            cancelTitle: 'Huỷ',
            centered: true,
          })
          .then(async value => {
            if (value) {
              this.showLoading = true
              const res = await DeviceService.approveUsageChange({
                id: item.id,
              })
              this.showLoading = false
              if (res.success || res.code === 1000) {
                this.showSuccessMx(`Duyệt phiếu chuyển mục đích thành công`)
                this.fetchData()
              } else this.showFailMx(`Duyệt phiếu chuyển mục đích thất bại`)
            }
          })
          .catch(() => {
            this.showLoading = false
          })
      },
      cancelItem(item) {
        const h = this.$createElement
        const messageVNode = h(
          'p',
          { class: 'f14' },
          `Bạn có chắc chắn huỷ phiếu chuyển mục đích không?`
        )
        this.$bvModal
          .msgBoxConfirm([messageVNode], {
            title: 'Lưu ý',
            okTitle: 'Xác nhận',
            cancelTitle: 'Huỷ',
            centered: true,
          })
          .then(async value => {
            if (value) {
              this.showLoading = true
              const res = await DeviceService.cancelUsageChange({
                id: item.id,
              })
              this.showLoading = false
              if (res.success || res.code === 1000) {
                this.showSuccessMx(`Huỷ phiếu chuyển mục đích thành công`)
                this.fetchData()
              } else this.showFailMx(`Huỷ phiếu chuyển mục đích thất bại`)
            }
          })
          .catch(() => {
            this.showLoading = false
          })
      },
    },
  }
</script>

<style scoped></style>
